import { memo } from "react";


import type { GoogleFreeBookingLinksHotelType } from "@/lib/gql/__generated__/graphql";

import { HOTEL_TYPE_OPTIONS } from "./constants/hotel-type-options";

import type { GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType } from "../../../hooks/use-google-free-booking-links-settings-hotel-type-form";
import type { UseFormRegister } from "react-hook-form";

type Props = {
	register: UseFormRegister<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType>;
	selectedHotelType: GoogleFreeBookingLinksHotelType | undefined;
	fieldName: "hotelType";
};

export const HotelTypeFieldset = memo(({ register, selectedHotelType, fieldName }: Props) => {
	return (
		<fieldset className="space-y-4">
			<legend className="sr-only">施設のタイプを選択してください</legend>

			{HOTEL_TYPE_OPTIONS.map((option, index) => {
				const isFirstOption = index === 0;
				const isSelected = selectedHotelType === option.value;
				const shouldBeFocusable = isSelected || (!selectedHotelType && isFirstOption);

				return (
					<label
						key={option.value}
						className={`
							relative flex cursor-pointer items-center rounded-lg border-[3px] p-4
							transition-all
							${isSelected ? "border-zinc-950" : "border-zinc-200 hover:border-zinc-300 hover:bg-zinc-50"}
						`}
					>
						<input
							type="radio"
							value={option.value}
							{...register(fieldName)}
							className="sr-only"
							aria-describedby={`hotel-type-${option.value}-description`}
							tabIndex={shouldBeFocusable ? 0 : -1}
						/>

						{/* カスタムラジオボタン */}
						<div
							className={`
								mr-4 flex h-5 w-5 items-center justify-center rounded-full border-2
								${selectedHotelType === option.value ? "border-zinc-950 bg-zinc-950" : "border-zinc-300"}
							`}
						>
							{selectedHotelType === option.value && <div className="h-2 w-2 rounded-full bg-white" />}
						</div>

						{/* アイコンとコンテンツ */}
						<div className="flex-1">
							<div className="mb-1 flex items-center gap-3">
								<h3 className="text-lg font-medium text-zinc-900">{option.label}</h3>
							</div>

							<div id={`hotel-type-${option.value}-description`}>{option.description}</div>
						</div>
					</label>
				);
			})}
		</fieldset>
	);
});
